(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultAgreementDetailController",
            LebaniegoYearResultAgreementDetailController
        );

        LebaniegoYearResultAgreementDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearResultAgreement",
        "LebaniegoYearResultAgreementFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearResultAgreementDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearResultAgreement,
        LebaniegoYearResultAgreementFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearResultAgreement = entity;
        vm.actualBusinessName = vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearResultAgreementFile.query(
            {
                id: vm.lebaniegoYearResultAgreement.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultAgreement = Object.assign({}, vm.lebaniegoYearResultAgreement);
            lebaniegoYearResultAgreement.gFile = {id: vm.lebaniegoYearResultAgreement.gFile.id};
            LebaniegoYearResultAgreement.update(lebaniegoYearResultAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearResultAgreementFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-result-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearResultAgreementFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearResultAgreementFile.query(
                        {
                            id: vm.lebaniegoYearResultAgreement.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-result-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyResultId: vm.lebaniegoYearResultAgreement.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearResultAgreementFile.query(
                            {
                                id: vm.lebaniegoYearResultAgreement.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultAgreement.gFile.id = item.gFileId;
            }
        }
    }
})();
